import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function usePreloader(duration = 2000) {
  const [showPreloader, setShowPreloader] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setShowPreloader(true);
    const timer = setTimeout(() => setShowPreloader(false), duration);

    return () => clearTimeout(timer);
  }, [location.pathname, duration]);

  return { showPreloader };
}
